import VenueLocationSummary from './VenueLocationSummary';

export default VenueLocationSummary;
